import S from 's-js';
import { HashSignal } from 'lib/hashSignal';

// Two-way signal for parsing the browser's hash into a location
// changes when the hash changes, changes the hash when it is changed
// when set, can take an optional second parameter to say whether the new location is added to the history or replaces the current location
export interface RequestSignal<T> { () : T | null; (loc : T, inplace : boolean) : T | null; }
export function RequestSignal<T>(hash : HashSignal, parse : (hash : string) => T | null, serialize : (loc : T) => string) : RequestSignal<T> {
    const _request = S(() => parse(hash()));
    return function request(loc? : T, inplace? : boolean) {
        return arguments.length === 0 ? _request() : (hash(serialize(loc!), inplace), loc!); 
    }
}



// WEBPACK FOOTER //
// ./lib/requestSignal.ts